/**
 * HrSynthesisCockpitPrint — page « Synthèse » du PDF People.
 * Reprend FIDÈLEMENT l'onglet Synthèse (cockpit masse à date → atterrissage,
 * effectif & rotation, graphe des salaires bruts) en réutilisant le composant
 * d'écran HrYearEndSimulationPage en mode embedded (mêmes cartes, même style).
 */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HrYearEndSimulationPage from '../HrYearEndSimulationPage';
import PrintReportHeader from './PrintReportHeader';

export default function HrSynthesisCockpitPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  // Le composant écran charge ses données en interne ; on signale « prêt » après
  // un court délai (le document d'aperçu a de toute façon un repli global).
  useEffect(() => {
    const t = setTimeout(() => { onDataReady && onDataReady('synthese'); }, 2000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line

  return (
    <section className="ppl-print__section ppl-print__section--cockpit">
      <PrintReportHeader category="People" title={t('phrases:p_ab761b3579')} year={year} tenant={activeTenant} editedAt={editedAt} />
      <div className="ppl-print__screen-embed">
        <HrYearEndSimulationPage embedded unit="chf" activeTenant={activeTenant} year={year} />
      </div>
    </section>
  );
}
